import { withDevToolsStub } from "@angular-architects/ngrx-toolkit";

import { version } from "../../package.json";
import { LANGUAGES } from "../app/api/local-144/models/languages-array";
import type { Environment } from "./types/environment.interface";

export const environment: Environment = {
    storeInstallUrl: "https://links.local116.monlocal.app/store",
    apiUrl: "https://mon-local-api-365742318808.northamerica-northeast1.run.app",
    availableLanguages: LANGUAGES,
    defaultLanguage: "fr",
    firebase: {
        apiKey: "AIzaSyDEw5jDvmyz2MUC1usF78m6Z_a9LdOMEWk",
        authDomain: "les-locaux-prod.firebaseapp.com",
        projectId: "les-locaux-prod",
        storageBucket: "les-locaux-prod.firebasestorage.app",
        messagingSenderId: "365742318808",
        appId: "1:365742318808:web:63efda8f7991c8917463ad"
    },
    sentry: {
        dsn: "https://8056c8ac98c215331d4ba30c74a02234@o341312.ingest.us.sentry.io/4511129479348224",
        environment: "production",
        enableLogs: true,
        enabled: true,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        tracePropagationTargets: ["https://mon-local-api-365742318808.northamerica-northeast1.run.app"],
        tracesSampleRate: 1.0
    },
    version,
    withDevtools: withDevToolsStub
};
